jQuery(function () {
    var isPlanned = $('#inspection-action-data').data('isplanned');
    var data = $('#inspection-action-data');
    if (!isPlanned) {
        $('.ts-inspection-action-month-select').prop('disabled', 'disabled');
        $('.ts-inspection-action-year-select').prop('disabled', 'disabled');
    }
    $('.ts-inspection-action-month-select, .ts-inspection-action-year-select').on('change', function () {
        handleInspectionRequest();
    });
    $('.ts-inspection-action-toggle-planning').on('click', function () {
        data.data('isplanned', !data.data('isplanned'));
        handleInspectionRequest();
        var inspectionPlanningToggle = $(this).find('.toggle-switch');
        if (!inspectionPlanningToggle.hasClass('active')) {
            $('.ts-inspection-action-month-select').prop('disabled', false);
            $('.ts-inspection-action-year-select').prop('disabled', false);
        }
        else {
            $('.ts-inspection-action-month-select').prop('disabled', 'disabled');
            $('.ts-inspection-action-year-select').prop('disabled', 'disabled');
        }
        inspectionPlanningToggle.toggleClass('active');
    });
});
var data = $('#inspection-action-data');
$('.ts-handle-inspection-action').on('click', function () {
    data.data('started', !data.data('started'));
    handleInspectionRequest($(this).data('gtmlabel'));
});
function handleInspectionRequest(label) {
    var componentId = data.data('id');
    var month = $('.ts-inspection-action-month-select').val();
    var year = $('.ts-inspection-action-year-select').val();
    var isStarted = data.data('started');
    var isPlanned = data.data('isplanned');
    $.ajax({
        type: 'PUT',
        url: '/kontroll/hantera',
        data: { componentId: componentId, isStarted: isStarted, isPlanned: isPlanned, plannedCompletionYear: year, plannedCompletionMonth: month },
        success: function () {
            if (isStarted) {
                var categoryName = 'Inspection';
                var category = 'MV ' + categoryName;
                var actionName = isStarted ? 'started' : 'canceled';
                var action = categoryName + ' ' + actionName;
                window['dataLayer'].push({
                    'event': 'MinVilla_Started',
                    'eventCategory': category,
                    'eventAction': action,
                    'eventLabel': label
                });
            }
        }
    });
}
